<div class="flex-column-center-full margin-top20">
    <h2>{{'Enter pin' | translate}}</h2>
    <input [(ngModel)]="pin" class="margin-top20" #search type="text" (keyup.enter)="onLogin()" (input)="showError = false">
    <div class="red" *ngIf="showError"> {{'Wrong pin | translate}}!</div>
    <ion-button class="margin5" (click)="onLogin()">{{'Login' | translate}}</ion-button>
</div>

